import type {
  UpdatePreferencesRequest,
  UpdatePreferencesResponse,
} from '@eloquor/api-contract';
import { apiFetch } from './client';

export async function updatePreferences(
  patch: UpdatePreferencesRequest
): Promise<UpdatePreferencesResponse> {
  return apiFetch<UpdatePreferencesResponse>('/users/me/preferences', {
    method: 'PATCH',
    json: patch,
  });
}
